import React from 'react';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-user-star-line',
      title: 'Personal Brand Management',
      description:
        'Build and enhance your professional identity in the sports industry. We help athletes, coaches, and executives develop authentic personal brands that open doors and create opportunities.',
      benefits: [
        'Brand strategy development',
        'Digital presence optimization',
        'Media training',
        'Reputation management',
      ],
    },
    {
      icon: 'ri-handshake-line',
      title: 'Sponsorship Relationship Management',
      description:
        'Develop and maintain valuable partnerships for sustainable growth. We support organisations and individuals in building sponsor relationships that deliver mutual value and long-term success.',
      benefits: [
        'Sponsor identification',
        'Proposal development',
        'Relationship management',
        'Performance reporting',
      ],
    },
    {
      icon: 'ri-team-line',
      title: 'Recruitment',
      description:
        'Find the right talent to strengthen your sports organisation. Our specialist recruitment service connects you with professionals who understand sport and can drive your organisation forward.',
      benefits: [
        'Role profiling',
        'Candidate sourcing',
        'Assessment processes',
        'Onboarding support',
      ],
    },
    {
      icon: 'ri-trophy-line',
      title: 'Skill & Talent Management',
      description:
        'Identify, develop and retain top performers in your team. We help you build talent pipelines and create environments where your best people want to stay and grow.',
      benefits: [
        'Talent identification',
        'Development planning',
        'Succession planning',
        'Retention strategies',
      ],
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Management',
      description:
        'Drive excellence through structured performance systems. We design and implement performance frameworks that align individual goals with organisational objectives.',
      benefits: [
        'Performance frameworks',
        'Goal setting systems',
        'Review processes',
        'Feedback culture',
      ],
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Training & Development',
      description:
        'Upskill your people with targeted learning programmes. From leadership development to technical skills, we create training solutions that deliver measurable improvements.',
      benefits: [
        'Training needs analysis',
        'Programme design',
        'Delivery & facilitation',
        'Impact measurement',
      ],
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Coaching & Mentoring',
      description:
        'Unlock potential through personalised guidance and support. Our coaching and mentoring programmes help individuals overcome challenges and achieve their professional goals.',
      benefits: [
        'One-to-one coaching',
        'Mentoring programmes',
        'Leadership coaching',
        'Career development',
      ],
    },
    {
      icon: 'ri-organization-chart',
      title: 'Organisational Development & Change',
      description:
        'Transform your structure and culture for lasting success. We guide organisations through change, helping you build cultures that support high performance and sustainable growth.',
      benefits: [
        'Culture assessment',
        'Change management',
        'Structure design',
        'Implementation support',
      ],
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="space-y-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-3xl p-8 md:p-12 hover:shadow-xl transition-all duration-300"
            >
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <div className="flex items-start gap-6 mb-6">
                    <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#0066FF] to-[#0052CC] rounded-xl flex-shrink-0">
                      <i className={`${service.icon} text-3xl text-white`}></i>
                    </div>
                    <div>
                      <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628] mb-3">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 text-lg leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6">
                  <h4 className="text-sm font-semibold text-[#0066FF] uppercase tracking-wide mb-4">
                    Key Benefits
                  </h4>
                  <ul className="space-y-3">
                    {service.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-check-line text-[#0066FF] text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700 text-sm">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
